import {ReactNode, useContext, useEffect, useState} from "react";
import AppContext from "./context/AppContext";
import {useApi} from "./api";
import './AuthWrapper.scss'

type Props = {
    children: ReactNode
    onLoggedIn: (username: string, sessionId: string|null) => void,
}

export default ({ children, onLoggedIn }: Props) => {
    const api = useApi()
    const { loggedIn } = useContext(AppContext)

    const [ checked,   setChecked   ] = useState(false)
    const [ loggingIn, setLoggingIn ] = useState(false)
    const [ error,     setError     ] = useState<string|null>(null)
    const [ username,  setUsername  ] = useState('')
    const [ password,  setPassword  ] = useState('')

    useEffect(() => {
        (async () => {
            const info = await api.getAuthInfo()
            if (info.loggedIn) onLoggedIn(info.username, null)
            setChecked(true)
        })()
    }, [])

    const login = async (e: any) => {
        e.preventDefault()
        setError(null)
        setLoggingIn(true)
        const res = await api.login(username, password)
        if (res.error)     setError(res.error)
        if (res.sessionId) onLoggedIn('admin', res.sessionId)
        setLoggingIn(false)
    }

    if (!checked) {
        return (
            <div className="auth-loading">
                <span className="spin"/>
            </div>
        )
    }

    if (loggedIn) return <>{children}</>

    return (
        <div className="auth-screen">
            <form className="auth-card" onSubmit={login}>
                <div className="auth-brand">memo</div>

                <label className="auth-label" htmlFor="au">Username</label>
                <input
                    id="au"
                    type="text"
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                    autoFocus
                    disabled={loggingIn}
                />

                <label className="auth-label" htmlFor="ap">Password</label>
                <input
                    id="ap"
                    type="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    disabled={loggingIn}
                />

                {error && <div className="auth-error">{error}</div>}

                <button className="auth-btn" type="submit" disabled={loggingIn}>
                    {loggingIn ? 'Signing in…' : 'Sign in'}
                </button>
            </form>
        </div>
    )
}
